


































































































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import Banner from "@/zh-website/src/components/website/Swiper/Banner.vue";
import { HomeService } from "@/zh-website/src/views/Homes/service";
import ReadTo from "@/zh-website/src/views/partner/supplier/ReadTo.vue";
import {RegService} from "@common/service/base-service/reg";
@Component({
  components: {
    Banner,
    ReadTo
  }
})
export default class Feedback extends Vue {
  isCheck = false;
  bannerData = {
    font1: "合作反馈",
    font3: "请填下您的反馈，工作人员将尽快联系您",
    button: "",
    style: {
      "background-image":
        'url("' + require("../../assets/feed_banner.jpg") + '")',
      height: "420px"
    }
  };
  codeImg = "";
  ruleForm = {
    content: "",
    product: "",
    name: "",
    telephone: "",
    email: "",
    city: "",
    unit: "",
    industry: "",
    budget: "",
    code: ""
  };
  codeNum = "";
  rules = {
    content: [{ required: true, message: "请输入您的反馈", trigger: "blur" }],
    name: [
      { required: true, message: "请输入您的姓名", trigger: "blur" },
      { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" }
    ],
    telephone: [{ validator: this.checkPhone, trigger: "blur" }],
    email: [{ validator: this.checkEmail, trigger: "blur" }],
    city: [{ required: true, message: "请输入所在城市", trigger: "blur" }],
    budget: [{ required: true, message: "请输入您的预算", trigger: "blur" }],
    code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
    product: [{ required: true, message: "请选择产品", trigger: "change" }],
    industry: [{ required: true, message: "请选择行业", trigger: "change" }],
    unit: [{ required: true, message: "请输入所在单位", trigger: "blur" }]
  };

  productList: any = []; //产品列表
  industryList: any = []; //行业列表

  value = "";
  mounted() {
    this.getProduct();
    this.getIndustry();
    this.getCode();
  }
  setBudget(v){
    this.ruleForm.budget = v.replace(/[^\d.]/g,'')
  }
  //邮箱验证
  checkEmail(rule, value, callback) {
    const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
    if (!value) {
      return callback(new Error("邮箱不能为空"));
    }
    setTimeout(() => {
      if (mailReg.test(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的邮箱格式"));
      }
    }, 100);
  }
  //手机验证
  checkPhone(rule, value, callback) {
    const phoneReg = RegService.PHONE;
    if (!value) {
      return callback(new Error("电话号码不能为空"));
    }
    setTimeout(() => {
      // Number.isInteger是es6验证数字是否为整数的方法,但是我实际用的时候输入的数字总是识别成字符串
      // 所以我就在前面加了一个+实现隐式转换
      if (!Number.isInteger(+value)) {
        callback(new Error("请输入数字值"));
      } else {
        if (phoneReg.test(value)) {
          callback();
        } else {
          callback(new Error("电话号码格式不正确"));
        }
      }
    }, 100);
  }

  getCode() {
    HomeService.getCode().then(res => {
      this.codeImg = `data:image/png;base64,${res.data.code}`;
      this.codeNum = res.data.codeNum;
    });
  }

  submitForm(formName) {
    if (!this.isCheck) {
      this.$message.error("请仔细阅读并同意隐私协议");
      return;
    }
    (this.$refs[formName] as any).validate(valid => {
      if (valid) {
        HomeService.createFeedback({
          ...this.ruleForm,
          codeNum: this.codeNum,
          signStatus:this.isCheck
        }).then(res => {
          this.$message.success("提交成功！");
          this.getCode();
          this.resetForm(formName);
          this.codeNum = "";
        });
      } else {
        return false;
      }
    });
  }
  resetForm(formName) {
    (this.$refs[formName] as any).resetFields();
  }
  async subMission(data, formName) {
    //先调用接口
  }
  //改变验证码
  changeCode() {
    this.getCode();
  }
  async getProduct() {
    HomeService.getProductList({ type: 1 }).then(res => {
      this.productList = res.data.list;
    });
    // this.productList = [];
  }
  async getIndustry() {
    HomeService.getProductList({ type: 2 }).then(res => {
      this.industryList = res.data.list;
    });
  }
}
